import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Shield, Network, ChevronRight } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { useApp } from "@/context/AppContext";
import { api } from "@/lib/api";
import { VOICE_LANGS } from "@/lib/speech";


export default function ProfilePage() {
  const { t, lang, setLang, voiceLang, setVoiceLang, theme, setTheme, consent, setConsent, demoUser, setDemoUser, me, pLabel } = useApp();
  const initials = (me?.user?.name || "?").split(" ").map((w) => w[0]).slice(0, 2).join("");
  const [users, setUsers] = useState([]);
  useEffect(() => { api.get("/demo-users").then((r) => setUsers(r.data)); }, []);
  const sel = "h-11 w-full rounded-xl border border-input bg-card px-3 text-sm";
  return (
    <div className="space-y-5 px-4 pt-4" data-testid="profile-page">
      <div className="flex items-center gap-4 rounded-3xl border bg-card p-4 shadow-sm">
        <span className="flex h-16 w-16 shrink-0 items-center justify-center rounded-2xl bg-gradient-to-br from-[#8A1538] to-[#B8901F] text-xl font-bold text-white" aria-hidden="true" data-testid="profile-avatar">{initials}</span>
        <div className="min-w-0">
          <p className="truncate text-lg font-bold" data-testid="profile-name">{me?.user?.name}</p>
          <p className="truncate text-xs text-muted-foreground">{me?.user?.email}</p>
          <span className="mt-1 inline-block rounded-full bg-[hsl(var(--gold-soft))] px-2 py-0.5 text-[11px] font-semibold" data-testid="profile-persona">{pLabel(me?.user?.persona)}</span>
        </div>
      </div>
      <label className="block text-xs font-semibold">{t("switchPersona")}
        <select data-testid="profile-persona-select" value={demoUser} onChange={(e) => setDemoUser(e.target.value)} className={sel}>
          {users.map((u) => <option key={u.email} value={u.email}>{u.name} — {pLabel(u.persona)}</option>)}
        </select>
      </label>
      <div className="grid grid-cols-2 gap-3">
        <label className="text-xs font-semibold">{t("uiLanguage")}
          <select data-testid="profile-ui-lang-select" value={lang} onChange={(e) => setLang(e.target.value)} className={sel}>
            <option value="en">English</option><option value="ar">العربية</option>
          </select>
        </label>
        <label className="text-xs font-semibold">{t("voiceLanguage")}
          <select data-testid="profile-voice-lang-select" value={voiceLang} onChange={(e) => setVoiceLang(e.target.value)} className={sel}>
            {VOICE_LANGS.map((l) => <option key={l.code} value={l.code}>{l.name}</option>)}
          </select>
        </label>
      </div>
      <div className="divide-y rounded-2xl border bg-card shadow-sm">
        <div className="flex min-h-[56px] items-center justify-between px-4">
          <span className="text-sm font-medium">{t("theme")}: {theme === "dark" ? t("dark") : t("light")}</span>
          <Switch data-testid="profile-theme-switch" checked={theme === "dark"} onCheckedChange={(v) => setTheme(v ? "dark" : "light")} aria-label={t("theme")} />
        </div>
        <div className="flex min-h-[56px] items-center justify-between gap-3 px-4 py-2">
          <span className="text-sm font-medium">{t("consent")}</span>
          <Switch data-testid="profile-consent-switch" checked={consent} onCheckedChange={setConsent} aria-label={t("consent")} />
        </div>
        <Link to="/architecture" data-testid="profile-architecture-link" className="flex min-h-[56px] items-center gap-3 px-4 text-sm font-medium"><Network size={18} /> <span className="flex-1">{t("architecture")}</span><ChevronRight size={16} className="q1-flip" /></Link>
        <Link to="/admin" data-testid="profile-admin-link" className="flex min-h-[56px] items-center gap-3 px-4 text-sm font-medium"><Shield size={18} /> <span className="flex-1">{t("adminPortal")}</span><ChevronRight size={16} className="q1-flip" /></Link>
      </div>
      <p className="text-center text-[11px] text-muted-foreground">{t("sandbox")}</p>
    </div>
  );
}
